"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _context = require("../../context");

var DropdownUl = (0, _context.styledWithTheme)('ul')(function (_ref) {
  var selectors = _ref.theme.selectors,
      hasPadding = _ref.hasPadding;
  return {
    listStyleType: 'none',
    padding: hasPadding ? selectors.space('S200') : 0,
    margin: '0',
    overflowY: 'auto',
    backgroundColor: selectors.color('neutral0'),
    ':focus': {
      outline: 'none'
    }
  };
});
DropdownUl.displayName = 'DropdownUl';
var _default = DropdownUl;
exports.default = _default;